import { useContext, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import AddressForm from "../../components/deliveryLoctions/AddressForm";
import { PlusIcon } from "@heroicons/react/20/solid";

import AddressCard1 from "../../components/deliveryLoctions/AddressCard1";

import { getDeliveryLocations } from "../../utils/zulalWebAPI";
import { UserContext } from "../../context/user.context";

const AddressBook = () => {
  const [formMode, setFormMode] = useState(null); // 'add' | 'edit'
  const [selectedAddress, setSelectedAddress] = useState(null);
  const { currentUser } = useContext(UserContext);

  // Assuming addresses are passed as props
  // const addresses = [
  //   {
  //     LocationId: 1,
  //     Label: "Home",
  //     RecipientName: "John Doe",
  //     Phone: "1234567890",
  //     AddressLine1: "123 Main St",
  //     City: "New York",
  //     Country: "USA",
  //   },
  //   {
  //     LocationId: 2,
  //     Label: "Office",
  //     RecipientName: "Jane Smith",
  //     Phone: "0987654321",
  //     AddressLine1: "456 Elm St",
  //     City: "Los Angeles",
  //     Country: "USA",
  //   },
  //   {
  //     LocationId: 3,
  //     Label: "Work",
  //     RecipientName: "Alice Johnson",
  //     Phone: "9876543210",
  //     AddressLine1: "789 Oak St",
  //     City: "Chicago",
  //     Country: "USA",
  //   },
  // ];

  // Load delivery locations from API
  const [addresses, setAddresses] = useState([]);
  const [addressFlag, setAddressFlag] = useState(false); // Flag to trigger re-render
  useEffect(() => {
    // Fetch addresses when the component mounts or formMode changes

    const fetchAddresses = async () => {
      //get customerCode from UserContext
      //console.log(`Current Customer code from Address Book: ${currentUser}`);
      const customerCode = currentUser.customerCode;
      //console.log(`customerCode from Address Book: ${customerCode}`);
      const response = await getDeliveryLocations(customerCode);

      setAddresses(response.data || []); // Set to empty array if no data is returned
    };

    fetchAddresses();
  }, [formMode]);

  const handleAdd = () => {
    setSelectedAddress(null);
    setFormMode("add");
    windowScrollToTop(); // Scroll to top when opening the form
  };

  const handleEdit = (address) => {
    setSelectedAddress(address);
    setFormMode("edit");
    windowScrollToTop(); // Scroll to top when opening the form
  };

  const handleCloseForm = () => {
    setFormMode(null);
    setSelectedAddress(null);
    windowScrollToTop(); // Scroll to top when closing the form
  };

  const refreshList = async () => {
    //await fetchAddresses(); // Fetch the updated list

    //get customerCode from UserContext
    //console.log(`Current Customer code from Address Book: ${currentUser}`);
    const customerCode = currentUser.customerCode;
    const response = await getDeliveryLocations(customerCode);
    setAddresses(response.data || []); // Update addresses with the fetched data

    setFormMode(null); // Ensure formMode is reset to prevent Add Form from opening
    windowScrollToTop(); // Scroll to top after refreshing the list
  };

  function windowScrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  return (
    <div className="mx-auto mr-4 ml-4 mb-28">
      <div className="text-navarbarText text-3xl font-poppins font-medium mb-8">
        Your Addresses
        <p className="text-darkTextColor font-poppins text-C12">
          Create / Update / Remove your addresses
        </p>
      </div>

      {/* Address Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
        {/* Add Address Box */}
        <div
          onClick={handleAdd}
          className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-md h-full 
                        shadow-md cursor-pointer hover:bg-gray-50 transition"
        >
          <div className="text-center">
            <div className="text-xl text-gray-400 mb-2">
              <PlusIcon className="h-8 w-8 mx-auto" />
              <div className="text-lg text-gray-500 font-medium">
                <button className="bg-blue-600 text-white px-4 py-2 rounded mb-4">
                  Add Address
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Address Cards */}
        {/* check if addresses have address to show otherwise display no delivery location found */}
        {addresses.length === 0 ? (
          <div className="text-center">
            <div
              className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-md h-full 
                        shadow-md cursor-pointer hover:bg-gray-50 transition"
            >
              <div className="text-lg text-gray-500 font-medium">
                <p className="bg-blue-600 text-white px-4 py-2 rounded mb-4">
                  No Delivery Location Found
                </p>
              </div>
            </div>
          </div>
        ) : (
          addresses.map((address) => (
            <AddressCard1
              key={address.locationId}
              address={address}
              onEdit={handleEdit}
              refreshList={refreshList}
              totalLocations={addresses.length}
            />
          ))
        )}
      </div>
      {/* add and edit form */}
      <div>
        <AnimatePresence>
          {formMode && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="mt-6"
            >
              <AddressForm
                mode={formMode}
                address={selectedAddress}
                onClose={handleCloseForm}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default AddressBook;
